// components/common/LabeledToggle.jsx
import React from "react";

/**
 * Toggle switch with "Enable" / "Disable" text inside the track.
 *
 * @param {string}   id        - unique id for the checkbox input
 * @param {boolean}  checked   - current checked state
 * @param {Function} onChange  - (checked: boolean) => void
 * @param {boolean}  disabled  - disables the toggle
 */
const LabeledToggle = ({ id, checked, onChange, disabled = false }) => (
  <div className="labeled-toggle-wrapper">
    <label className={`labeled-toggle ${disabled ? "is-disabled" : ""}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
      />
      <span className="labeled-toggle__slider">
        <span className="labeled-toggle__text labeled-toggle__text--on">
          Enabled
        </span>
        <span className="labeled-toggle__text labeled-toggle__text--off">
          Disabled
        </span>
      </span>
    </label>
  </div>
);

export default LabeledToggle;